<div class="main">
  <div class="container">
    <div class="left">
      <div class="header">
        {{'DRIVERMAPVIEW.drivers' | translate}}
      </div>
      <div class="driversList" *ngIf="driversList.length">
        <div class="card" *ngFor="let driver of driversList" (click)="plotOnMap(driver)">
          <div class="ring-container">
              <div class="ringring"></div>
              <div class="circle"></div>
          </div>
          <div class="avatar">
            <img src="assets/avatar.png"  alt="">
          </div>
          <div class="details">
            <div class="name">{{driver.name}}</div>
            <div class="mobile"><i class="material-icons">phone</i>{{driver.mobile}}</div>
            <div class="vehicle"><img src="assets/delivery-truck.svg"  alt="">{{driver.vehicle_no}}</div>
          </div>
        </div>

      </div>
    </div>
    <div class="center map">
      <div id="driverMap">
      </div>
    </div>
    <div class="right">
        <div class="card">
          <div class="header">
            {{'DRIVERMAPVIEW.currentLocation' | translate}}
          </div>
          <div class="section">
            {{driverDetails.current_address}}
          </div>
        </div>
    </div>
  </div>
</div>
